/**
 * monthreports service
 */

import Resource from './resource'

export default new Resource('monthreports')



// WEBPACK FOOTER //
// ./src/libraries/services/monthreports.js